import { render, staticRenderFns } from "./Template4.vue?vue&type=template&id=ced44290&scoped=true&"
import script from "./Template4.vue?vue&type=script&lang=js&"
export * from "./Template4.vue?vue&type=script&lang=js&"
import style0 from "./Template4.vue?vue&type=style&index=0&id=ced44290&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced44290",
  null
  
)

export default component.exports